import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

// CssBaseline foi movido para dentro do ThemeProvider (App.js) para que o
// background/cor do body sigam o tema ativo (claro/escuro).
ReactDOM.render(<App />, document.getElementById("root"));

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
